// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3YxC1qye6Gktz7I2ySG8Nl {\n  padding-top: 24px;\n}\n\n/* The !importants below are because of legacy-bs-override */\n._34eVxCAFM2RpZQOzuXjDWw {\n  margin-left: 16px !important;\n}\n\n._34eVxCAFM2RpZQOzuXjDWw:hover {\n  color: white !important;\n}\n\n._2Eq26WIUmhW--AOclIVC1U input[type=number] {\n  font-weight: 400 !important;\n  width: 100px;\n}\n\n._2CI66ToIfgSiDxiS7QSBTp {\n  padding: 3px;\n  border: 1px solid rgb(196, 195, 196);\n  border-radius: 4px;\n}", ""]);
// Exports
exports.locals = {
	"container": "_3YxC1qye6Gktz7I2ySG8Nl",
	"jumpButton": "_34eVxCAFM2RpZQOzuXjDWw",
	"jumpInput": "_2Eq26WIUmhW--AOclIVC1U",
	"paginationBorder": "_2CI66ToIfgSiDxiS7QSBTp"
};
module.exports = exports;
